import styled from "@emotion/styled";
import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { CommCenterTicket } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import Flex from "../../Generic/Flex";
import { getLastChatMessage, isChatMessageUnread } from "../utils/chatUtils";
import ChatCard from "./ChatCard";
import { default as ChatsCircleVector } from "/public/assets/chats-circle-icon.svg?react";

interface Props {
  tickets: CommCenterTicket[];
  onTicketClick: (ticket: CommCenterTicket) => void;
}

const ChatsPreviewContainer = (props: Props) => {
  return (
    <ChatsPreviewContainer.Root>
      {props.tickets.length === 0 ? (
        <ChatsPreviewContainer.NoMessagesContainer>
          <Flex direction="column">
            <ChatsCircleVector />
            <p>{translate(STRINGS.NO_PREVIOUS_CONVERSATIONS)}</p>
          </Flex>
        </ChatsPreviewContainer.NoMessagesContainer>
      ) : (
        props.tickets.map((ticket) => (
          <ChatCard
            key={ticket.id.toString()}
            agencyName={translate(STRINGS.MEDFLYT_HOME_CARE)}
            contactName={ticket.assignedTo?.name ?? translate(STRINGS.MEDFLYT)}
            message={getLastChatMessage(ticket) ?? translate(STRINGS.NEW_MESSAGE)}
            lastMessageDateTime={LocalDateTime.ofInstant(
              ticket.messages[ticket.messages.length - 1].createdAt
            )}
            unreadMessagesCount={ticket.messages.filter(isChatMessageUnread).length}
            onClick={() => props.onTicketClick(ticket)}
          />
        ))
      )}
    </ChatsPreviewContainer.Root>
  );
};

ChatsPreviewContainer.Root = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

ChatsPreviewContainer.NoMessagesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  color: var(--gray-600);

  svg {
    height: 64px;
  }
`;

export default ChatsPreviewContainer;
